export const API_ENDPOINTS = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/auth/me',
  },
  bookingRequests: '/booking-requests',
  bookingRequestsFilterSuggestions: '/booking-requests/filter-suggestions',
  bookingRequestsImport: '/booking-requests/import',
  drafts: '/drafts',
  inspections: '/inspections',
  inspectionDetail: (id: string) => `/inspections/${id}`,
  inspectionPdf: (id: string) => `/inspections/${id}/pdf`,
  orders: '/orders',
  ordersInternalOrderReferenceExists: (value: string) => `/orders/internal-order-reference/exists?value=${encodeURIComponent(value)}`,
  tenantCentres: '/meta/tenant-centres',
  locations: '/meta/tenant-centres',
  factoryLocationsBySupplier: (supplierId: string) => `/meta/factory-locations/by-supplier/${supplierId}`,
  inspectionLevels: '/meta/inspection-levels',
  bookingStatuses: '/meta/booking-request-statuses',
  controlPoints: '/meta/control-points',
  defects: '/meta/defects',
  factories: '/common/factories',
  products: '/common/products',
  /** Master product CRUD (tenant-scoped; role-guarded on backend). */
  productsCreate: '/products',
  productsCheckCode: (code: string) => `/products/check-code/${encodeURIComponent(code)}`,
  productCategories: '/common/product-categories',
  customers: '/common/customers',
  factoriesBySupplier: (supplierId: string) => `/common/factories/by-supplier/${supplierId}`,
  factoriesBySupplierCodes: (supplierCodes: string[]) =>
    `/common/factories/by-supplier-codes?supplierCodes=${encodeURIComponent(supplierCodes.join(','))}`,
  suppliers: '/common/suppliers',
  suppliersByFactory: (factoryId: string) => `/common/suppliers/by-factory/${factoryId}`,
  portsByLocation: (locationId: string) => `/meta/ports/by-location/${locationId}`,
  portsByFactoryCode: (factoryCode: string) => `/meta/ports/by-factory-code/${encodeURIComponent(factoryCode)}`,
  cities: '/common/cities',
  autoplanConfig: '/meta/configurations/autoplan',
  publicHolidays: '/meta/holidays',
  masterDataSuppliers: '/master-data/suppliers',
  masterDataFactories: '/master-data/factories',
  sizeChartsByCode: (productCode: string) => `/size-charts/by-code/${productCode}`,
} as const;
